import React, { useEffect, useState } from 'react';
type ScrambleTextProps = {
  text: string;
  className?: string;
};
const GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&/\\';
/**
 * "Enigma decoding" reveal — the word resolves out of scrambled glyphs, each
 * character locking into place at a staggered moment. Re-runs on text change.
 */
export function ScrambleText({
  text,
  className = ''
}: ScrambleTextProps) {
  const [display, setDisplay] = useState(text);
  useEffect(() => {
    const target = text;
    const reveals = target.split('').map((_, i) => 4 + Math.floor(Math.random() * 7) + i * 1.4);
    const maxFrame = Math.max(...reveals, 1) + 2;
    let frame = 0;
    const id = window.setInterval(() => {
      frame += 1;
      let out = '';
      for (let i = 0; i < target.length; i++) {
        if (target[i] === ' ') out += ' ';else if (frame >= reveals[i]) out += target[i];else out += GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
      }
      setDisplay(out);
      if (frame >= maxFrame) {
        setDisplay(target);
        window.clearInterval(id);
      }
    }, 45);
    return () => window.clearInterval(id);
  }, [text]);
  return <span aria-hidden="true" className={className} data-id="element-188">
      {display}
    </span>;
}